export const UNLINKED_STATES = {
  noPatient: "NO_PATIENT",
  noPregnancy: "NO_PREGNANCY",
};

/**
 * Which of the two needs-attention states a message is in, or null when it is fully
 * attached and does not belong in the queue at all.
 *
 * The two are worth separating because they fail differently. A message with no
 * patient is simply invisible — it is on no chart, and the broker has already been
 * acked so it will never arrive again. A message with a patient but no pregnancy
 * *is* visible on the chart, and is the reason a practice sees MN-CMS sending refuse
 * that pregnancy every single time with nothing on screen explaining why.
 */
export const getUnlinkedState = (message) => {
  if (!message?.patientId) return UNLINKED_STATES.noPatient;
  if (!message?.pregnancyId) return UNLINKED_STATES.noPregnancy;

  return null;
};

const STATE_DESCRIPTIONS = {
  [UNLINKED_STATES.noPatient]: {
    label: "No patient",
    detail:
      "We could not match this message to a patient, so it is on no chart. Read it to identify the patient, then assign it.",
  },
  [UNLINKED_STATES.noPregnancy]: {
    label: "No pregnancy",
    detail:
      "Matched to a patient but to no pregnancy — usually the hospital sent this before the pregnancy was created here. MN-CMS sending stays blocked until a pregnancy is attached.",
  },
};

export const describeUnlinkedState = (state) => STATE_DESCRIPTIONS[state] ?? null;
